// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getStorage, connectStorageEmulator } from "firebase/storage";

// Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "purpleDx-Production",
  // IMPORTANT: this must be the BUCKET, not a domain.
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
    "purpleDx-Production.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGE_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialise Firebase
export const firebaseApp = initializeApp(firebaseConfig);

// Singletons you can import elsewhere if helpful
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
export const fns = getFunctions(firebaseApp, "europe-west2");
export const storage = getStorage(firebaseApp);

/* ---------- Local emulators ---------- */
const USE_EMU = process.env.REACT_APP_FIREBASE_USE_EMULATORS === "true";
if (USE_EMU) {
  // Only connect to what you’re actually emulating
  // connectAuthEmulator(auth, "http://127.0.0.1:9099");
  // connectFirestoreEmulator(db, "127.0.0.1", 8080);
  connectFunctionsEmulator(fns, "127.0.0.1", 5001);
  connectStorageEmulator(storage, "127.0.0.1", 9199);
  console.info("[Firebase] connected to local emulators");
}
